import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Store } from '@df/catalog/store/store';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ICmsClientModule } from '@icms/client/icms-client.module';
@Component({
    selector: 'see-range-in-store-product-status',
    templateUrl: './see-range-in-store-product-status.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ICmsClientModule, TranslationModule]
})
export class SeeRangeinStoreProductStatusComponent {
    @Input()
    store?: Store;
}
